import {gql} from "@apollo/client/core";

export const OrderHistoryPaymentViewFragment = gql`
    fragment OrderHistoryPaymentViewFragment on OrderHistoryViewPayment {
        paymentId
        paymentMethodType
        status
        amount
        isVoucher
        isCancellable
        approvedShippingAmount
    }
`;
